import { useEffect, useMemo, useRef, useState } from "react"
import { FormikProps } from "formik"
import { ReceiptConfirmOrderDialogController } from "../components/receipt/ReceiptConfirmOrderDialogController"
import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { DynamicMainFormValues, MeetingServiceTabValues } from "../components/form/formTypes"
import { CreateOrderTabConfig } from "../components/CreateOrderTypeTabs"
import { computeOrderFormStatus, OrderFormStatus } from "./helpers"
import { OrderFormContainer } from "./OrderFormContainer"
import { CreateOrderType } from "../helpers"

type OrderFormControllerProps = Readonly<{
    initialOrderType: CreateOrderType
    filteredTabButtonConfig: CreateOrderTabConfig<CreateOrderType>[]
    orderDetails?: MeetingServiceOrder
}>

export function OrderFormController({
    initialOrderType,
    filteredTabButtonConfig,
    orderDetails,
}: OrderFormControllerProps) {
    const [confirmOrderDialog, setConfirmOrderDialog] = useState<MeetingServiceTabValues | null>(null)
    const [currentOrderType, setCurrentOrderType] = useState<CreateOrderType | null>(null)
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const formRef = useRef<FormikProps<DynamicMainFormValues>>(null)

    const computedStatus = useMemo(() => computeOrderFormStatus(orderDetails), [orderDetails?.id])

    const orderFormStatusRef = useRef<OrderFormStatus>(computedStatus)

    useEffect(() => {
        orderFormStatusRef.current = computedStatus
    }, [computedStatus])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [])

    const handleSubmitMeetingService = (values: MeetingServiceTabValues) => {
        setConfirmOrderDialog(values)
    }
    const handleOpenResourceBooking = (type: CreateOrderType) => {
        setConfirmOrderDialog(null)
        setCurrentOrderType(type)

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            setCurrentOrderType(null)
        }, 300)
    }
    const handleAddNewMeetingService = () => {
        setConfirmOrderDialog(null)
        formRef.current?.resetForm()
        orderFormStatusRef.current = computeOrderFormStatus()
    }

    return (
        <>
            <OrderFormContainer
                orderDetails={orderDetails}
                initialOrderType={initialOrderType}
                newOrderType={currentOrderType}
                filteredTabButtonConfig={filteredTabButtonConfig}
                handleSubmitMeetingService={handleSubmitMeetingService}
                formikRef={formRef}
                orderFormStatusRef={orderFormStatusRef}
            />

            {confirmOrderDialog && (
                <ReceiptConfirmOrderDialogController
                    onClose={() => setConfirmOrderDialog(null)}
                    handleOpenResourceBooking={handleOpenResourceBooking}
                    handleAddNewMeetingService={handleAddNewMeetingService}
                    orderDetails={confirmOrderDialog}
                    orderFormStatusRef={orderFormStatusRef}
                />
            )}
        </>
    )
}
